export const validateIdCard = (rule, value, callback) => {
  var regExp = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
  if (regExp.test(value)) {
    callback();
  } else {
    callback(new Error("请输入正确的身份证号"));
  }
};

export const validatePhone = (rule, value, callback) => {
  var val = value == null ? "" : String(value).trim();
  if (/^1\d{10}$/.test(val)) {
    callback();
  } else {
    callback(new Error("请输入正确的手机号"));
  }
};

/** 可选手机号：空值通过，有值时校验格式 */
export const validatePhoneOptional = (rule, value, callback) => {
  if (value === undefined || value === null || String(value).trim() === "") {
    callback();
    return;
  }
  validatePhone(rule, String(value).trim(), callback);
};

/** 可选邮箱：空值通过，有值时校验格式 */
export const validateEmailOptional = (rule, value, callback) => {
  if (value === undefined || value === null || String(value).trim() === "") {
    callback();
    return;
  }
  const email = String(value).trim();
  const regExp = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  if (regExp.test(email)) {
    callback();
  } else {
    callback(new Error("请输入正确的邮箱"));
  }
};

/**
 * 教师登录账号：仅支持大小写字母、中文、数字、下划线（不必全有），最长 10 位
 */
export const validateTeacherAccount = (rule, value, callback) => {
  if (value === undefined || value === null || String(value).trim() === "") {
    callback(new Error("请输入登录账号"));
    return;
  }
  const account = String(value).trim();
  if (account.length > 10) {
    callback(new Error("登录账号不能超过10位"));
    return;
  }
  if (!/^[\u4e00-\u9fa5A-Za-z0-9_]+$/.test(account)) {
    callback(new Error("仅支持大小写字母、中文、数字、下划线"));
    return;
  }
  callback();
};

/** 可选 URL：空值通过，有值时校验 http(s) 链接（支持 IP、端口、hash 路由等） */
export const validateUrlOptional = (rule, value, callback) => {
  if (value === undefined || value === null || String(value).trim() === "") {
    callback();
    return;
  }
  const url = String(value).trim();
  try {
    const parsed = new URL(url);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      callback();
      return;
    }
  } catch (e) {
    // fall through
  }
  callback(new Error("请输入正确的链接，需以 http:// 或 https:// 开头"));
};

export const validateChineseName = (rule, value, callback) => {
  if (!/^[\u4e00-\u9fa5]{2,5}$/.test(value)) {
    callback(new Error("姓名为2~5个汉字"));
    return;
  }
  callback();
};

export const validateUserKey = (rule, value, callback) => {
  if (!/^[A-Za-z0-9]{8,12}$/.test(value)) {
    callback(new Error("账号为8~12位，仅支持大小写字母和数字"));
    return;
  }
  callback();
};

const STUDY_DATE_FORMAT = /^\d{4}-\d{2}-\d{2}$/;

function parseStudyDate(value) {
  const date = new Date(value.replace(/-/g, "/"));
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

function startOfToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today.getTime();
}

export const validateStudyStartTime = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  if (!STUDY_DATE_FORMAT.test(value)) {
    callback(new Error("开始时间格式不正确"));
    return;
  }
  if (parseStudyDate(value) < startOfToday()) {
    callback(new Error("开始时间不能小于今天"));
    return;
  }
  callback();
};

export const createValidateStudyEndTime = getStartTime => (
  rule,
  value,
  callback
) => {
  if (!value) {
    callback();
    return;
  }
  if (!STUDY_DATE_FORMAT.test(value)) {
    callback(new Error("结束时间格式不正确"));
    return;
  }
  const endTime = parseStudyDate(value);
  const startTimeValue = getStartTime();
  if (startTimeValue) {
    if (!STUDY_DATE_FORMAT.test(startTimeValue)) {
      callback();
      return;
    }
    if (endTime < parseStudyDate(startTimeValue)) {
      callback(new Error("结束时间不能小于开始时间"));
      return;
    }
  } else if (endTime < startOfToday()) {
    callback(new Error("结束时间不能小于今天"));
    return;
  }
  callback();
};

export const validatePassword = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  if (value.length < 6 || value.length > 14) {
    callback(new Error("密码长度为6~14位，只能由数字、英文字母和标点符号组成"));
    return;
  }
  if (!/^[\dA-Za-z!-/:-@\[-`{-~]+$/.test(value)) {
    callback(new Error("密码长度为6~14位，只能由数字、英文字母和标点符号组成"));
    return;
  }
  callback();
};

export const generateStrongPassword = (length = 12) => {
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const digits = "0123456789";
  const special = "!@#$%^&*";
  const all = lower + upper + digits + special;
  const len = Math.min(Math.max(length, 6), 14);
  const chars = [
    lower[Math.floor(Math.random() * lower.length)],
    upper[Math.floor(Math.random() * upper.length)],
    digits[Math.floor(Math.random() * digits.length)],
    special[Math.floor(Math.random() * special.length)]
  ];
  for (let i = chars.length; i < len; i++) {
    chars.push(all[Math.floor(Math.random() * all.length)]);
  }
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
};



// WEBPACK FOOTER //
// ./src/utils/validate.js